import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import {
  selectCPMFTrackingForecastModelId,
} from 'redux/reducers/meteorologyFieldsTrackingForecastControlPanelReducer';
import {
  useLazyGetTrackingForecastDetailedViewMembersQuery,
} from 'services/api/Meteorology/Fields/TrackingForecast/DetailedView';

export default function useMemberOptions() {
  const modelId = useSelector(selectCPMFTrackingForecastModelId);

  const [trigger, {
    currentData, isFetching,
  }] = useLazyGetTrackingForecastDetailedViewMembersQuery();
  // `currentData` (não `data`): ao re-selecionar o modelo, o `useLazyQuery` mantém
  // em `data` os membros do modelo ANTERIOR durante o refetch do novo modelId.
  // Servir isso preenchia membros do modelo errado e disparava consulta vazia
  // (#1822). Enquanto o modelId atual não resolveu, a lista vem vazia.
  const members = modelId && currentData ? currentData : [];

  useEffect(() => {
    if (modelId) {
      trigger({
        modelId,
      });
    }
  }, [modelId, trigger]);

  return { members, isFetching };
}
